import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { Button } from '@alfa-bank/site-button-v2';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';
import { TimerTextDesktop as TimerText } from '@alfa-bank/site-timer-text/desktop';
import { ProgressBar } from '@alfa-bank/site-progress-bar';
import { BlockDesktop } from '@alfa-bank/site-block/desktop';
import { sendEvent } from '@alfa-bank/site-helpers-common/browser/send-event';

import type { IDeps, TDraftOffer } from '../models';

import { DraftOfferDesktop as Component } from './draft-offer';

export const DraftOfferDesktop = createWidget<IDeps, TDraftOffer>({
    sendEvent,
    Button,
    Text,
    TimerText,
    ProgressBar,
    Block: BlockDesktop,
})(Component);
